<template>
  <div id="welcome" class="main-layout">
    <section id="first">
      <navbar/>
      <div class="container">
        <div id="login" class="card">
          <div class="card-body">
            <div class="logo header">
              <img class="left" :src="$t('pages.welcome.identity_img')">
              <img class="right" src="/img/mhavie_grand_age.png">
            </div>
            <Login />
            <div class="logo footer">
              <img :src="$t('pages.welcome.ripph_img')">
            </div>
            <div style="text-align: center" >
              <p v-html="$t('pages.welcome.developed_by')"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import Navbar from '~/components/Navbar'
import { mapGetters } from 'vuex'

export default {
  layout: 'empty',
  middleware: 'guest',

  components: {
    Navbar
  },

  metaInfo () {
    return { title: this.$t('home') }
  },

  data: () => ({
    title: window.config.appName
  }),

  computed: {
    ...mapGetters({
      authenticated: 'auth/check'
    })
  }
}
</script>

<style lang="scss" scoped>
$color: #fff;
$color-dark: #333;
$color-primary: #2980b9;

#welcome {
  /*background-color: #fff;*/
  color: #333;
}

.card-body {
  padding:60px;
}

a {
  color: #3498db;
  font-weight: bold;

  &:hover {
    color: #3498db;
  }
}
img {
  max-width:50%;
}
p {
  padding: 0.5rem;
}

h1 {
  font-size: 2rem;
  font-weight: 300;
}

section {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  padding: 100px 0 20px 0;
  position: relative;
}

footer {
  color: #999;
  font-size: 0.7rem;
  padding: 100px 200px;

  p {
    padding: 1rem;
  }

  #partners {
    img {
      margin: 0 20px;
      max-height: 60px;
    }
  }
}

#first {
  background-attachment: fixed;
  background-image: url('/img/welcome.jpg');
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  color: $color-dark;

  height: 125vh;
  min-height: 800px;
  padding: 0;
  width: 100%;
  z-index: 10;

  .logo {
    padding-bottom: 10px;
    text-align: center;

    img {
      max-width: 30%;
    }

    .left {
      float: left;
      max-width: 40%;
    }

    .right {
      float: right;
    }
  }

  .logo.header {
    padding-bottom: 130px;
  }

  #login {
    box-shadow: 0 10px 20px 0 #2c3e50;
    color: $color-dark;
    left: 50%;
    margin-left: -400px;
    margin-top: -345px;
    padding: 0;
    position: absolute;
    top: 50%;
    width: 700px;
  }
}

.scroll-to {
  border: 2px solid $color-dark;
  border-radius: 100%;
  bottom: 60px;
  box-shadow: 0 0 0px 0 transparentize($color-dark, 1.0);
  color: $color-dark;
  cursor: pointer;
  display: block;
  font-size: 20px;
  height: 40px;
  left: 50%;
  line-height: 36px;
  margin-top: 100px;
  margin-left: -20px;
  margin-top: 20px;
  position: absolute;
  text-align: center;
  transition: all 0.3s;
  width: 40px;

  &:hover {
    background-color: $color-primary;
    border-color: $color-primary;
    box-shadow: 0 0 0px 10px transparentize($color-primary, 0.5);
    color: #fff;
  }
}

.scroll-to-light {
  border: 2px solid $color;
  color: $color;
}

// Small devices
@media (max-width: 576px) {
  #login {
    padding: 0 !important;
    margin-top:10px !important;
    position:relative !important;
    margin: 10px 0 0 0 !important;
    width: 100% !important;
    left: 0% !important;
    .logo.header {
      padding-bottom: 50px !important;
    }
  }
}
</style>
<style lang="scss">
$color: #fff;
$color-dark: #333;
$color-input: rgba($color, 0.2);
$color-input-dark: rgba($color-dark, 0.2);

@media (min-width: 992px) {
#welcome .navbar {
  background: white !important;
  box-shadow: unset;

  .dropdown-toggle {
    //background-color: $color-input-dark;
    color: $color-dark;
    border-radius: 20px;
    padding-left: 1rem;
    padding-right: 1rem;

    &:hover {
      background-color: $color;
      color: $color-dark;
    }
  }
  .logo { fill: $color; }
}
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/pages/welcome.vue